<script>

    import {createEventDispatcher, onDestroy} from "svelte";
    import {get} from "svelte/store";
    import {Splide, SplideSlide} from "@splidejs/svelte-splide";
    import {publishConfigStore, tenantKeyStore, toggleFavorite} from "./../core/app-store.js";
    import {
        addToCart,
        cartTotalStore
    } from "./../cart/cart-store.js";
    import ModsSelector from "./../components/ModsSelector.svelte";
    import {screensStore, toggleDetailsScreen} from "../core/screens-manager.js";
    import {getPriceWithMods} from "./details.js";
    import AddToCartButton from "./AddToCartButton.svelte";
    import CartPreview from "./CartPreview.svelte";
    import {mediaUrlStore} from "../core/app-store.js";
    import {t} from "../core/i18n/language-store.js";

    const dispatch = createEventDispatcher();
    const publishConfig = get(publishConfigStore);
    const tenantKey = get(tenantKeyStore);
    let fullscreen = false;
    let record;
    let price;
    let showAll = false;

    let videoUnmuted = publishConfig.videoUnmuted === true;
    let autoplayVideo = publishConfig.autoplayVideo === true;
    let loopVideo = publishConfig.loopVideo === true;
    let hideVideoControls = publishConfig.hideVideoControls === true;

    const storeSubscriptions = [
        screensStore.subscribe(screens => {
            record = screens.detailsRecord;
            price = getPriceWithMods(record);
        })
    ];

    onDestroy(() => {
        for (let i = 0; i < storeSubscriptions.length; i++){
            storeSubscriptions[i]();
        }
    });

    function close() {
        fullscreen = false;
        price = undefined;
        toggleDetailsScreen();
    }

    function toggleFullscreenMedia() {
        fullscreen = !fullscreen;
    }

    function toggleFavoriteHandler () {
        toggleFavorite({detail: {recordId: record.id, isFavorite: !record.isFavorite}});
    }

    function modsChangeHandler () {
        price = getPriceWithMods(record);
    }

    function addToCartHandler() {
        addToCart(record, {price: price.totalPrice, weight: price.selectedVariant?.weight}, price.selectedVariantIdx, price.selectedMods);
    }

</script>

<style>
    .details-container {}
    .close-backdrop {
        background: var(--backdrop-color);
        display: block;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
    }
    .details-block {

        top: 2rem;
        z-index: 1001;
        border-top-left-radius: 2rem;
        border-top-right-radius: 2rem;

        position: fixed;
        width: 100vw;
        background: var(--bg-color);
        padding-bottom: 1rem;
        overflow-y: auto;
        bottom: 0;
    }
    @media (min-width: 524px) {
        .details-container {
            width: 100vw;
            height: 100vh;
            display: flex;
            justify-content: center;
            position: absolute;
            z-index: 1000;
        }
        .close-backdrop {
            display: block;
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
        .close-button {
            position: fixed;
            top: 0;
            right: 0;
            z-index: 10;
            border-bottom-right-radius: 1.5rem;
            font-size: 1.25rem;
            padding: 1.25rem 1.25rem 1.25rem 1.5rem;
            line-height: 1;
            cursor: pointer;
        }
        .details-block {
            max-width: 500px;
            box-shadow: 0 10px 24px 0 rgba(0, 0, 0, .15);
            margin-top: 5rem;
            margin-bottom: 2rem;
            border-radius: var(--border-radius-xxl);
            max-height: calc(100vh - 10rem);
            min-height: unset;
        }
    }
    .details-block--cart-not-empty {
        padding-bottom: 4rem;
    }
    @media (max-width: 524px) {
        .close-button {
            position: fixed;
            right: 0;
            z-index: 10000;
            background: var(--bg-color);
            border-bottom-left-radius: 2rem;
            border-top-right-radius: 2rem;
            padding: 1.5rem 1.25rem 1rem 1.5rem;
            font-size: 1.25rem;
            line-height: 1;
            top: 2rem;
            opacity: 0;
            animation: close-button-appears .2s ease-out .2s forwards;
        }
    }
    .media-block {
        margin: .75rem .75rem 0 .75rem;
        overflow: hidden;
        min-height: 2.5rem;
    }
    .media-fallback {
        width: 128px;
    }
    .image,
    .video {
        background: var(--no-media-color);
        width: 100%;
        height: 100%;
        /*height: 58vh;*/
        /*max-height: 58vh;*/
        object-fit: cover;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .video video {
        object-fit: cover;
        overflow: clip;
        height: 100%;
        width: 100%;
    }
    .info-block {
        padding: 0 1.25rem 1.25rem 1.25rem;
    }
    .title {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding-top: 1rem;
        padding-bottom: 0.5rem;
    }
    h2 {
        font-weight: 500;
        margin: 0;
        padding: 0;
        overflow-wrap: break-word;
        word-break: break-word;
    }
    .add-favorite {
        background: var(--fav-bg-color);
        border-radius: 50%;
        width: 2.25rem;
        height: 2.25rem;
        min-width: 2.25rem;
        min-height: 2.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: background .2s ease-in-out;
    }
    .add-favorite--active {
        background: var(--fav-color);
        color: var(--fav-font-color);
    }

    .description {
        line-height: 1.3rem;
        font-weight: 400;
        letter-spacing: .2px;
        white-space: pre-wrap;
    }

    .nutritional {
        display: flex;
        gap: 1rem;
        color: var(--chips-font-color);
        font-size: 1rem;
        font-weight: 400;
    }
    .nutritional > div {
        flex-basis: 30vw;
        text-align: center;
        background: var(--chips-bg-color);
        border-radius: var(--border-radius-xs);
        padding: 0.5rem;
    }

    .allergens {
        font-size: .9rem;
        letter-spacing: .3px;
    }

    @keyframes close-button-appears {
        from {
            opacity: 0;
        }
        to {
            opacity: .8;
        }
    }
</style>

{#if (record) }

    <div class="details-container">

        <div class="close-backdrop fade-in-animation" on:click={close}></div>

        <!-- CLOSE BUTTON -->
        <div class="close-button pointer" on:click={close}>
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Cross"><path d="M20 20L4 4m16 0L4 20"/></svg>
        </div>

        <div class="details-block slide-up-animation layer-details {$cartTotalStore.count > 0 ? 'details-block--cart-not-empty' : ''}">

            <!-- MEDIA -->
            <div id="media" class="media-block {fullscreen ? 'media-block--full-screen' : ''} {!record?.media ? 'media-block--no-media' : ''}">

                <!-- SLIDER -->
                <Splide aria-label="{record?.name}" style="height: 100% !important; max-height: 100% !important">

                    {#if (record?.media || []).length === 0}
                        <SplideSlide>
                            <div class="image">
                                <img class="media-fallback" src="./images/fallback-image.svg" loading="lazy" alt="{record?.name}">
                            </div>
                        </SplideSlide>
                    {/if}

                    {#each (record?.media || []) as media}
                    <SplideSlide>
                        {#if (media.type === 'photo')}

                            <object class="image" data="{$mediaUrlStore}{media.ref || tenantKey}/_media_files/{media.name}" type="image/png">
                                <img class="media-fallback" src="./images/fallback-image.svg" alt="{record?.name}">
                            </object>
                        {/if}
                        {#if (media.type === 'video')}
                            <div class="video">
                                <video loading="lazy"
                                       muted={!videoUnmuted}
                                       autoplay={autoplayVideo}
                                       loop={loopVideo}
                                       controls={!hideVideoControls}>
                                    <source src="{$mediaUrlStore}{media.ref || tenantKey}/_media_files/{media.name}" type="video/mp4">
                                    <track kind="captions">
                                </video>
                            </div>
                        {/if}
                    </SplideSlide>
                    {/each}
                </Splide>

            </div>

            <!-- INFO BLOCK -->
            <div class="info-block">

                <!-- TITLE -->
                <div class="title flex-between">
                    <div class="flex-fill">
                        <h2>{ record?.name || '' }</h2>
                    </div>

                    <div class="add-favorite pointer {record.isFavorite ? 'add-favorite--active' : ''}" on:click={toggleFavoriteHandler}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Heart"><path d="M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 0 0 1.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"/></svg>
                    </div>
                </div>

                <p class="description">{ record?.description || '' }</p>

                <div class="flex-vertical gap-1">

                    <!-- NUTRITIONAL -->
                    <div class="nutritional">

                        {#if record?.nutritionalValue?.calories}

                            <div>
                                <div>{record.nutritionalValue?.calories}</div>
                                <div>{$t('nutrition.calories')}</div>
                            </div>
                        {/if}

                        {#if record?.nutritionalValue?.proteins}

                            <div>
                                <div>{record.nutritionalValue?.proteins}г</div>
                                <div>{$t('nutrition.proteins')}</div>
                            </div>
                        {/if}

                        {#if record?.nutritionalValue?.fats}

                            <div>
                                <div>{record.nutritionalValue?.fats}г</div>
                                <div>{$t('nutrition.fats')}</div>
                            </div>
                        {/if}

                        {#if record?.nutritionalValue?.carbohydrates}

                            <div>
                                <div>{record.nutritionalValue?.carbohydrates}г</div>
                                <div>{$t('nutrition.carbs')}</div>
                            </div>
                        {/if}

                    </div>

                    <!-- ALLERGENS -->
                    {#if ($publishConfigStore.showAllergens)}
                        {#if (record?.allergens || []).length > 0}
                        <div class="allergens">
                            <span>{$t('allergens.contains')}:</span>
                            {#each (record?.allergens || []) as allergen, index}
                                <span>{ allergen }</span>{#if index < record.allergens.length-1}<span>, </span>{/if}
                            {/each}
                        </div>
                        {/if}
                    {/if}

                    <!-- VARIANTS AND MODIFICATORS -->
                    <ModsSelector prices={record?.prices}
                                  mods={record?.mods}
                                  currency={publishConfig.currency}
                                  on:changed={modsChangeHandler}>
                    </ModsSelector>

                    <!-- ADD TO CART BUTTON -->
                    <AddToCartButton publishConfig={publishConfig}
                                     price={price}
                                     on:clicked={addToCartHandler}>
                    </AddToCartButton>

                    <!-- CART PREVIEW -->
                    <CartPreview record={record}
                                 price={price}
                                 publishConfig={publishConfig}>
                    </CartPreview>

                </div>

            </div>

        </div>
    </div>

{/if}
